import axios from 'axios';
import https from 'https'


    const DMB_API = axios.create({
    //baseURL: (process.env.VUE_APP_API) ? process.env.VUE_APP_API : 'http://localhost:8000',
    //baseURL: (process.env.VUE_APP_API) ? process.env.VUE_APP_API : 'https://opendmb.demibarrio.eu',
    baseURL: (process.env.VUE_APP_API) ? process.env.VUE_APP_API : 'https://lacartaweb.com',
    httpsAgent: new https.Agent({
      rejectUnauthorized: false,
    })
});

export default DMB_API;